module.exports = __webpack_public_path__ + "media/application/images/default-e763bc588c4f3341d7b2b0a42d7b7488.svg";